/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_1_TitleInputs */

const en_pc_rv_1_title = /** @type {(inputs: Pc_Rv_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First launch`)
};

const zh_pc_rv_1_title = /** @type {(inputs: Pc_Rv_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首次启动`)
};

/**
* | output |
* | --- |
* | "First launch" |
*
* @param {Pc_Rv_1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_1_title = /** @type {((inputs?: Pc_Rv_1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_1_title(inputs)
	return zh_pc_rv_1_title(inputs)
});
export { pc_rv_1_title as "pc.rv.1.title" }